import { dataNormalizer } from 'data/core/utils';
import { spaceTabSchema } from 'data/spaces/schema';
export const spaceTabNormalizer = (data)=>dataNormalizer(data, spaceTabSchema);
